module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Goodbye, Tuscaloosa")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BEFORE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Let me tell you about my wife and my dog and our bathtub. How just minutes prior to the storm—minutes prior to peeling the cushions from the couch and positioning them over our heads—my dog and I stood barefoot in the grass staring up at a swirling sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She began to bark at it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quiet,” I hissed. “No barking at tornadoes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pulled the dog back inside, checked the television, but it wasn’t until the power cut out that we were prompted to enter the tub. The meteorologist—who would become a god that day—had just switched from radar screen to video feed, and in those final seconds before we were plunged into darkness, the TV revealed "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("a single gray cloud narrowing as if sucked toward the ground through a straw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flashback to the tornado drills of my youth—folded face-to-butt in the bowels of Lindley Elementary in Fort Wayne, Indiana. Face down and neck covered, in the rare moments when the drills turned real, I’d steal a glance at our lion mascot painted on the school’s cinderblock walls, hoping he might protect us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just days before, during a pep rally, our principal had made one thing clear: “Nobody messes with the Lions!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Not even tornadoes?")]), _vm._v(" I wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in the tub now, and there are no lions anywhere, just a dog that for the first time in her life is subdued. We are all humbled that day, but she is the first, her quivering head tucked tightly beneath my knee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here, in the bathtub, our privacy is on display: my dandruff shampoo, my wife’s pink disposable razor. To the left of these things sits our mango mandarin body wash, which I wonder if we’ll ever use again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My wife’s voice overpowers this wondering, overpowers the sound of the tree limbs scraping the bathroom window as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had to interview a Vietnam vet once,” she says from her place beneath a couch cushion. “Back in high school. For social studies. I drove all the way out to his house, and it was when we were having all those really big storms, remember? And so I got there and he said he’d forgotten I was coming. He said his son’s home had just gotten blown away and our meeting had slipped his mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d never found the proper time to tell me this story, but that late afternoon, trapped in a tub, I’ve at last become a perfect audience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("“We rode around in his golf cart,” she continues. “He told me of the destruction he’d seen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My wife, dog, and I pull closer into our bunker, awaiting what will later be called the second most deadly weather outbreak in recorded history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet somehow, through some luck, we are the glass eye in the storm that sees nothing. And we are the deaf ear, too, hearing only the "), _c('em', [_vm._v("drip, drip, drip")]), _vm._v(" of the rusted showerhead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A moment passes. Then another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it over yet?” my wife asks, peeking beneath her cushion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m not sure it’s even begun.")]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AFTER")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("I will spare you the destruction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can imagine, I’m sure, what a tree looks like "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("horizontal")]), _vm._v(", or a house "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("turned inside out")]), _vm._v(". You can imagine also what it means when people say “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("leveled")]), _vm._v(".” What it means when they say “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("vanished")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stories of "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("legs in")]), _vm._v(" the front yard, of "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("victims")]), _vm._v(" wrapped in trees like "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("tangled kites")]), _vm._v(". Stories of how all that people have left "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("in the world")]), _vm._v(" now fits neatly in a grocery cart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Do not read this too closely. I am trying to spare you "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("the broken glass and the blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What I can’t spare you is the strangeness of living in a tornado-torn town amid writers who, much like myself, have a tendency to turn everything poetic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Thirteen Ways of Looking at a Black[cloud]")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("In the [Emergency] Waiting Room")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our poet hands are softer than cream cheese, and though we hardly know how to swing an axe, this doesn’t keep us from "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("trying. But eventually we grow tired, sore, and return to our more familiar tools—paper and pen—as we rebuild our town word by word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But before all that—before the axes and the paper and the pen—my wife, dog, and I wake early to retrace the tornado’s path. It’s the morning after, and with each step, we try to make sense of our shifted landscape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("But the cars used to be here")]), _vm._v(", I think, running my eyes the length of the empty lot, "), _c('em', [_vm._v("so why are they now there?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Along the route I pick up a newspaper and listen for the prosody in the reports.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Read the repetition: “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("unrelenting")]), _vm._v(",” “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("unprecedented")]), _vm._v(",” “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("devastating")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And hear the cadence in the quotes: “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("digging with their hands")]), _vm._v(",” “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("sifted through the remains")]), _vm._v(",” “"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("First responders didn’t attend to the dead . . .")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every headline displays the word "), _c('span', {
    staticClass: "strike"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RAVAGED")])]), _vm._v(" or "), _c('span', {
    staticClass: "strike"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RUBBLE")])]), _vm._v(", and regardless of which story you read, you’re told to turn to page 7A.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But not before making a choice:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "strike"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEE DEATH")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("or")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEE SURVIVORS")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The morning after, we see a bit of both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We join the city’s pilgrimage, shuffling directionless down the center lane of 15th Avenue as the sun begins to rise. We are a tailgate without a football game, a processional without a funeral. Through it all, my dog pulls hard on her leash. She doesn’t like the sound of "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("chainsaws or shouting or")]), _vm._v(" silence, and she is overwhelmed with far too much to sniff—the bolt of cloth flung a "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("hundred yards from Hobby Lobby, the milk bottles still upright in the shell of a Krispy Kreme.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of this seems like a dream, which is the closest we’ve come to dreaming in twenty-four hours. We hadn’t slept well the previous night, mostly due to the students partying in the apartments behind our house. They’d blared their music louder than the warning sirens, allowing every sound to float down from their balconies, infiltrating our half sleep with shouts for Ping-Pong balls and Solo cups.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But we were kept awake also by the whispers we repeated beneath the sheets—“If we’d died,” my wife said, staring at the plus sign on her pregnancy test, “then no one would’ve known about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So many lost so much that day, but we still kept our secret.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 96
// module chunks = 0